<template>
    <mu-container class="mb-4">
        <br />
        <h4 v-if="action_flag == 1" class="text-center">{{ $t("new_invoice.title") }} </h4>
        <h4 v-if="action_flag == 2" class="text-center">{{ $t("new_invoice.title_resend") }}</h4>
        <h4 v-if="action_flag == 3" class="text-center">{{ $t("new_invoice.title") }} </h4>
        <p v-if="action_flag == 3" class="text-center">{{ $t("new_invoice.note_success_points") }} </p>
        <mu-expansion-panel :expand="true" class="panel-background" v-if="getProfile === null && action_flag == 1">
            <template slot="header">
                <p class="h5 blue-vp text-center">
                    {{ $t('traveller.title') }}
                </p>
            </template>

            <span>{{ $t('traveller.text_2') }}</span>

            <div class="row col-12 offset-sm-3 text-center">
                <div class="p-2">
                    <mu-text-field
                        data-cy=”traveller_auth-user-text”
                        v-no-paste
                        v-model="traveller_auth.user"
                        :label="$t('traveller.card_tiele')"
                        width-full>
                    </mu-text-field>

                </div>
                <div class="p-2">
                    <mu-text-field 
                        data-cy=”traveller_auth-password-text”
                        v-model="traveller_auth.password" 
                        :label="$t('traveller.password')" 
                        :action-icon="traveller_auth.visibility ? 'visibility_off' : 'visibility'" 
                        :action-click="() => (traveller_auth.visibility = !traveller_auth.visibility)" 
                        :type="traveller_auth.visibility ? 'text' : 'password'"
                        width-full>
                    </mu-text-field>
                </div>
            </div>
            <div class="col-12 text-center">
                <mu-button color="primary" @click="signTraveller()"  >
                    {{ $t('traveller.sign_in') }}
                </mu-button>
            </div>
        </mu-expansion-panel>
        <mu-col class="my-2" v-if="action_flag == 1">
            <div>
                <mu-select @change="CompleteInvoicing(id_invoicing)"
                    :label="$t('new_invoice.inputs.rfc')" v-model="id_invoicing"  v-if="complete_rfc"
                    full-width>
                    <mu-option v-if="billings.length == 0"
                        :label="$t('new_invoice.inputs.not_found')"
                        :value="$t('new_invoice.inputs.not_found')" disabled></mu-option>
                    <mu-option v-for="option, index in billings" :key="index"
                        :label="option.tax_id" :value="option.id"></mu-option>
                </mu-select>
                <mu-text-field v-model="rfc_invoicing" v-uppercase v-else
                        :label="$t('new_invoice.inputs.rfc')" 
                        label-float full-width></mu-text-field>
                <mu-switch @change="SwitchInvoicing()" v-model="complete_rfc"
                    :label="complete_rfc ? $t('new_invoice.inputs.manual') : $t('new_invoice.inputs.select') "></mu-switch>
            </div>
        </mu-col>
        
        <mu-col class="my-2" v-if="action_flag == 1">
            <mu-text-field 
            v-model="name_invoicing" 
            :label="$t('new_invoice.inputs.name')" 
            label-float full-width 
            :disabled="action_flag == 2">
            </mu-text-field>
        </mu-col>
        <mu-col class="my-2" v-if="action_flag != 3">
            <mu-text-field
                v-model="email_invoicing"
                :label="$t('new_invoice.inputs.email')"
                label-float
                full-width >
            </mu-text-field>
        </mu-col>
        <mu-col class="my-2" v-if="action_flag == 1">
            <mu-text-field
                v-model="cp_invoicing"
                v-numeric
                :label="$t('new_invoice.inputs.cp')"
                label-float
                full-width
                :disabled="action_flag == 2">
            </mu-text-field>
        </mu-col>
        <mu-col class="my-2" v-if="action_flag == 1">
                <mu-select v-model="use_invoicing"
                    :label="$t('new_invoice.inputs.useCfdi')"
                    label-float
                    full-width
                >
                    <template slot="selection" slot-scope="scope">
                        {{ scope.label }}
                    </template>
                    <mu-option 
                        style="color: black !important" 
                        v-for="(option, index) in uses_options" 
                        :key="option.id" :value="option.id"
                        :label="`${option.id == -1 ? '' : `(${option.id})`} ${option.label}`"
                    ></mu-option>
                </mu-select>
            </mu-col>
        <mu-col class="my-2" v-if="action_flag == 1">
            <mu-select
                v-model="regimen_invoicing"
                :label="$t('new_invoice.inputs.regimen_fiscal')"
                label-float
                full-width>
                    <template slot="selection" slot-scope="scope">
                        {{ scope.label }}
                    </template>
                <mu-option
                    style="color: black !important"
                    v-for="option in regimen_fiscal"
                    :key="option.id"
                    :value="option.id"
                    :label="`${option.id == -1 ? '' : `(${option.id})`} ${option.label}`">
                </mu-option>

            </mu-select>
        </mu-col>
        <mu-col>
            <mu-row>
                <mu-col class="text-center">
                    <h6 class="font-weight-bold">{{ $t("new_invoice.table.concepts") }}</h6>
                </mu-col>
                <mu-col class="text-center">
                    <h6 class="font-weight-bold">{{ $t("new_invoice.table.amount") }}</h6>
                </mu-col>
                <mu-col class="text-center">
                    <h6 class="font-weight-bold">{{ $t("new_invoice.table.method") }}</h6>
                </mu-col>
                <mu-col class="text-center">
                 <h6 class="font-weight-bold">{{ $t("new_invoice.table.can_invoice") }}</h6>
                </mu-col>
                <mu-col class="text-center">
                    <h6 class="font-weight-bold">{{ $t("new_invoice.table.can_send") }}</h6>
                </mu-col>
            </mu-row>
            <mu-row v-for="(key, index) in payments" :key="`payment_${index}`">
                <mu-col class="text-center mb-3">
                    <div class="m-0">
                        <label style="font-size: 17px">{{ key.concept }}</label>
                    </div>
                </mu-col>
                <mu-col class="text-center mb-3">
                    <div class="m-0">
                        <label class="font-weight-bold">${{ key.amount }}</label>
                    </div>
                </mu-col>
                <mu-col class="text-center mb-3">
                    <div class="m-0">
                        <label style="font-size: 17px">{{$t(`new_invoice.select_payment_type.${key.card_type}`) }}</label>
                    </div>
                </mu-col>
                <mu-col class="mb-3">
                    <div class="m-0 d-flex justify-content-center">
                        <vs-switch v-model="key.active_invoicing" success class="statusConcept"
                            :disabled="key.can_invoicing">
                        </vs-switch>
                    </div>
                </mu-col>
                <mu-col class="mb-3">
                    <div class="m-0 d-flex justify-content-center">
                        <vs-switch v-model="key.active_resend" success class="statusConcept"
                                :disabled="key.can_resend">
                        </vs-switch>
                    </div>
                </mu-col>
            </mu-row>
        </mu-col>
        <p class="text-danger">{{ $t("new_invoice.inputs.note") }}</p>
        <mu-row>
            <mu-col :span="4" :offset="(total_payments > add_payment) ? ((add_payment != 0) ? 1 : 4) : 4 " v-if="total_payments > add_payment">
                <div class="d-flex justify-content-center align-items-center">
                    <mu-button round color="success" @click="sendForm()">
                        {{ $t("new_invoice.button.send_invoice") }}
                    </mu-button>
                </div>
            </mu-col>
            <mu-col :span="4" :offset="(add_payment != 0) ? ((total_payments > add_payment) ? 1 : 4) : 4" v-if="add_payment != 0">
                <div class="d-flex justify-content-center align-items-center">
                    <mu-button round color="info" @click="resendForm()">
                        {{ $t("new_invoice.button.resend_invoice") }}
                    </mu-button>
                </div>
            </mu-col>
        </mu-row>
        <br>
    </mu-container>
</template>

<script>
// HELPERS
import _InvoicingHelper from "@/store/helpers/books/invoicing"
import _GlobalHelper from "@/store/helpers/global"
import _ReservationHelper from "@/store/helpers/reservation/reservation"
import _FrequentTravellerHelper from '@/store/helpers/frequenttraveller/frequenttraveller'
// VUEX
import { mapMutations, mapGetters, mapActions } from 'vuex'
export default {
    data() {
        return {
            traveller_auth: {
                user: null,
                password: null,
                visibility: false
            },
            only_points: false,
            code: null,
            last_name: null,
            action_flag: 1,
            payments: [],
            aux_payments: [],
            total_payments: 0,
            add_payment: 0,
            select_resend: 0,
            add_resend: 0,
            billings: [],
            id_invoicing: null,
            complete_rfc: false,
            email_invoicing: null,
            rfc_invoicing: null,
            cp_invoicing: null,
            regimen_invoicing: null,
            name_invoicing: null,
            use_invoicing: null,
            regimen_fiscal: [
                {
                    id: 601,
                    label: "General de Ley Personas Morales",

                },
                {
                    id: 603,
                    label: "Personas Morales con Fines no Lucrativos",
                },
                {
                    id: 605,
                    label: "Sueldos y Salarios e Ingresos Asimilados a Salarios",
                },
                {
                    id: 606,
                    label: "Arrendamiento",
                },
                {
                    id: 607,
                    label: "Régimen de Enajenación o Adquisición de Bienes",
                },
                {
                    id: 608,
                    label: "Demás ingresos",
                },
                {
                    id: 609,
                    label: "Consolidación",
                },
                {
                    id: 610,
                    label: "Residentes en el Extranjero sin Establecimiento Permanente en México",
                },
                {
                    id: 611,
                    label: "Ingresos por Dividendos (socios y accionistas)",
                },
                {
                    id: 612,
                    label: "Personas Físicas con Actividades Empresariales y Profesionales",
                },
                {
                    id: 614,
                    label: "Ingresos por intereses",
                },
                {
                    id: 615,
                    label: "Régimen de los ingresos por obtención de premios",
                },
                {
                    id: 616,
                    label: "Sin obligaciones fiscales",
                },
                {
                    id: 620,
                    label: "Sociedades Cooperativas de Producción que optan por diferir sus ingresos",
                },
                {
                    id: 621,
                    label: "Incorporación Fiscal",
                },
                {
                    id: 622,
                    label: "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",
                },
                {
                    id: 623,
                    label: "Opcional para Grupos de Sociedades",
                },
                {
                    id: 624,
                    label: "Coordinados",
                },
                {
                    id: 625,
                    label:
                        "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
                },
                {
                    id: 626,
                    label: "Régimen Simplificado de Confianza",
                },
                {
                    id: 628,
                    label: "Hidrocarburos",
                },
                {
                    id: 629,
                    label: "De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales",
                },
                {
                    id: 630,
                    label: "Enajenación de acciones en bolsa de valores",
                },
            ],
            uses_options: [{
                id: 'G03',
                label: 'G03 - GASTOS EN GENERAL',
            }, {
                id: 'S01',
                label: 'S01 - SIN EFECTOS FISCALES',
            }],
        }
    },
    computed: {
        loading: {
            set(data) {
                this.set_loading(data)
            },
            get() { },
        },

        ...mapGetters({
            getProfile: _FrequentTravellerHelper.getters.profile
        }),
    },
    watch: {
        getProfile(data) {
            if (this.getProfile == null) {
                this.billings = []
                this.id_invoicing = null
                this.rfc_invoicing = null
                this.cp_invoicing = null
                this.regimen_invoicing = null
                this.name_invoicing = null
                this.use_invoicing = null
                this.email_invoicing = null
            }
            else {
                this.email_invoicing = (this.getProfile.email != null) ? this.getProfile.email : null
            }
        }
    },
    methods: {
        ...mapActions({
            itineraryData: _ReservationHelper.actions.itineraryData,
            sendInvoicing: _InvoicingHelper.actions.sendInvoicingForm,
            resend: _InvoicingHelper.actions.resend,
            singIn: _FrequentTravellerHelper.actions.session,
            profile: _FrequentTravellerHelper.actions.profile,
        }),
        ...mapMutations({
            set_loading: _GlobalHelper.mutations.loading,
            set_alert_simple: _GlobalHelper.mutations.setAlertSimple,
            setProfile: _FrequentTravellerHelper.mutations.profile,
        }),
        async searchData() {
            await this.itineraryData({
                code: this.code,
                last_name: this.last_name,
            }).then(({ success, data, error }) => {
                if (!success && error === undefined) {
                    this.set_alert_simple({
                        show: true,
                        title: "api.title_error_invoice",
                        message: message,
                    })
                    return
                }
                if (!success && error.length >= 0) {
                    error.forEach((key) => {
                        if (key.code === "reservation_not_found") {
                            message.push("module_itinerary.alert.errors.reservation_not_found")
                        }
                        else if (key.code === "reservation_inactive") {
                            message.push("module_itinerary.alert.errors.reservation_inactive")
                        }
                        else if (key.code === "reservation_temporal") {
                            message.push("module_itinerary.alert.errors.reservation_temporal")
                        } else {
                            this.message.push(`api.commons.alert.error.error_proccess_request`)
                        }
                    })

                    if (message.length === 0) {
                        message.push("api.commons.alert.error.default_error_information")
                    }
                    this.set_alert_simple({
                        show: true,
                        title: "api.title_error_invoice",
                        message: message,
                    })
                    return
                }
                if (success && data) {
                    this.aux_payments = data.payments
                    if (this.aux_payments.length != 0) {
                        this.getData(this.aux_payments)
                    }
                }
            })
        },
        getData(payments_received) {
            this.total_payments = payments_received.length
            if (this.total_payments == 0) {
                this.set_alert_simple({
                    show: true,
                    title: "new_invoice.title",
                    message: ["new_invoice.alert.errors.empty_payments"],
                })
                this.$router.push({
                    name: "itinerary-search",
                })
            }

            this.add_payment = 0
            let new_payments = []
            this.payments = []
            for (let index in payments_received) {
                let payment = payments_received[index]
                if (payment.concept) {
                    if (payment.invoice_uuid == null && payment.invoice_id == null) {
                        if (!["traveller_purchased", "traveller_win"].includes(payment.card_type)) {
                            payment.can_invoicing = false
                            payment.active_invoicing = true

                            payment.can_resend = true
                            payment.active_resend = false
                        } else {
                            payment.can_invoicing = true
                            payment.active_invoicing = false

                            payment.can_resend = true
                            payment.active_resend = false
                            this.total_payments -= 1
                            this.only_points = true
                        }
                    } else if (payment.invoice_uuid != null && payment.invoice_id != null) {
                        if (!["traveller_purchased", "traveller_win"].includes(payment.card_type)) {
                            payment.can_invoicing = true
                            payment.active_invoicing = false

                            payment.can_resend = false
                            payment.active_resend = true
                        } else {
                            payment.can_invoicing = true
                            payment.active_invoicing = false

                            payment.can_resend = true
                            payment.active_resend = false
                        }
                        this.add_payment += 1
                    }
                    payment.card_type = payment.card_type ? payment.card_type : "cash"
                    new_payments.push(payment)
                }
            }

            this.payments = JSON.parse(JSON.stringify(new_payments))

            if (this.total_payments == 0 && this.only_points) {
                this.action_flag = 3
            }
            else if (this.total_payments > this.add_payment) {
                this.action_flag = 1
                this.set_alert_simple({
                    show: true,
                    title: "new_invoice.title",
                    message: ["new_invoice.alert.date_limit"],
                })
            } else {
                this.action_flag = 2
            }
            this.loading = { show: false, message: null }
        },
        sendForm() {
            const message = []
            this.loading = { show: true, message: `<h5>${this.$i18n.t("loading.global")}</h5>`, }

            let rfcInvoicing =
                this.$validator.hasValue(this.rfc_invoicing) &&
                    this.$validator.isString(this.rfc_invoicing) &&
                    !this.$validator.isEmptyString(this.rfc_invoicing)
                    ? this.rfc_invoicing.trim()
                    : ""

            let emailInvoicing =
                this.$validator.hasValue(this.email_invoicing) &&
                    this.$validator.isString(this.email_invoicing) &&
                    !this.$validator.isEmptyString(this.email_invoicing)
                    ? this.email_invoicing.trim()
                    : ""

            let cpInvoicing =
                this.$validator.hasValue(this.cp_invoicing) &&
                    this.$validator.isString(this.cp_invoicing) &&
                    !this.$validator.isEmptyString(this.cp_invoicing) &&
                    /^\d{4,6}/.test(this.cp_invoicing)
                    ? this.cp_invoicing.trim()
                    : ""

            let nameInvoicing =
                this.$validator.hasValue(this.name_invoicing) &&
                    this.$validator.isString(this.name_invoicing) &&
                    !this.$validator.isEmptyString(this.name_invoicing)
                    ? this.name_invoicing.trim()
                    : ""

            let regimenInvoicing =
                this.$validator.hasValue(this.regimen_invoicing) &&
                    this.$validator.isInt(this.regimen_invoicing.toString(), 1)
                    ? this.regimen_invoicing
                    : ""

            let useInvoicing = 
                (this.$validator.hasValue(this.use_invoicing) && 
                    this.$validator.isString(this.use_invoicing) && 
                        !this.$validator.isEmptyString(this.use_invoicing)) 
                ? this.use_invoicing.trim() 
                : ''

            rfcInvoicing = this.$validator.isRFC(rfcInvoicing) ? rfcInvoicing : null
            emailInvoicing = this.$validator.isEmail(emailInvoicing) ? emailInvoicing : null

            if (rfcInvoicing === null) {
                message.push("new_invoice.alert.errors.empty_rfc_invoicing")
            }
            if (emailInvoicing === null) {
                message.push("new_invoice.alert.errors.empty_email_invoicing")
            }
            if (cpInvoicing === "") {
                message.push("new_invoice.alert.errors.empty_cp_invoicing")
            }
            if (nameInvoicing === "") {
                message.push("new_invoice.alert.errors.empty_name_invoicing")
            }
            if (useInvoicing === '') {
                message.push('new_invoice.alert.errors.empty_use_invoicing')
            }
            if (regimenInvoicing === "") {
                message.push("new_invoice.alert.errors.empty_regimen_invoicing")
            }
            if (message.length > 0) {
                this.loading = { show: false, message: null }
                this.set_alert_simple({
                    show: true,
                    title: "new_invoice.alert.errors.title",
                    message: message,
                })
                return
            }

            let body_payments = {
                code: this.code,
                brand_id: this.$config.brand_id,
                rfc: rfcInvoicing,
                email: emailInvoicing,
                cp: cpInvoicing,
                regimen: regimenInvoicing,
                source: "web",
                payments: [],
                pac: "smarter",
                name: nameInvoicing,
                use_cfdi: useInvoicing,
                user_id: this.$config.user_id,
            }

            for (let index in this.payments) {
                let payment = this.payments[index]
                if ( payment.invoice_id === null && payment.invoice_uuid === null && payment.active_invoicing) {
                    payment.payment_type = payment.card_type
                    body_payments.payments.push(payment)
                }
            }

            if (body_payments.payments.length === 0) {
                message.push("new_invoice.alert.errors.empty_payments_selected")
            }

            if (message.length > 0) {
                this.loading = { show: false, message: null }
                this.set_alert_simple({
                    show: true,
                    title: "new_invoice.alert.errors.title",
                    message: message,
                })
                return
            }

            body_payments.payments = JSON.stringify(body_payments.payments)

            this.sendInvoice(body_payments)
        },
        async sendInvoice(dataInvoice) {
            const message = []
            await this.sendInvoicing(dataInvoice).then(({ success, data, error }) => {
                if (!success && error === undefined) {
                    this.loading = { show: false, message: null }
                    this.set_alert_simple({
                        show: true,
                        title: "api.title_error_invoice",
                        message: ["api.commons.alert.error.default_error_information"],
                    })
                    return
                }
                if (!success && error.length >= 0) {
                    error.forEach((key, index) => {
                        if (key.detail != undefined && key.detail != null && key.detail != "") {
                            message.push(`new_invoice.alert.errors.${key.code}`, key.detail.detail)
                        } else if (key.code != "" && key.code != "error_proccess_request") {
                            message.push(`new_invoice.alert.errors.${key.code}`)
                        } else {
                            message.push(`api.commons.alert.error.error_proccess_request`)
                        }
                    })
                    this.loading = { show: false, message: null }

                    this.set_alert_simple({
                        show: true,
                        title: "api.title_error_invoice",
                        message: message,
                    })
                    return
                }
                if (success && data != null) {
                    this.set_alert_simple({
                        show: true,
                        title: "new_invoice.title",
                        message: ["new_invoice.alert.success"],
                    })
                    this.$forceUpdate()
                    this.searchData()
                }
            })
        },
        async resendForm() {
            const message = []
            this.select_resend = 0
            this.add_resend = 0
            let send_payments = 0
            this.loading = { show: true, message: `<h5>${this.$i18n.t("loading.global")}</h5>`, }

            let emailInvoicing =
                this.$validator.hasValue(this.email_invoicing) &&
                    this.$validator.isString(this.email_invoicing) &&
                    !this.$validator.isEmptyString(this.email_invoicing)
                    ? this.email_invoicing.trim()
                    : ""
            emailInvoicing = this.$validator.isEmail(emailInvoicing) ? emailInvoicing : null

            if (emailInvoicing === "") {
                message.push("new_invoice.alert.errors.empty_email_invoicing")
            }

            if (message.length > 0) {
                this.loading = { show: false, message: null }
                this.set_alert_simple({
                    show: true,
                    title: "new_invoice.alert.errors.title",
                    message: message,
                })
                return
            }

            for (let index in this.payments) {
                let payment = this.payments[index]
                if ( payment.invoice_id !== null && payment.invoice_uuid !== null && payment.active_resend) {
                    let invoice_id = payment.invoice_id
                    let invoice_uuid = payment.invoice_uuid

                    this.select_resend += 1
                    await this.resendInvoice( this.code, this.$config.brand_id, invoice_uuid, emailInvoicing, invoice_id)
                }
                if (!payment.active_resend) {
                    send_payments += 1
                }
            }

            if (this.payments.length == send_payments) {
                message.push("new_invoice.alert.errors.empty_payments_resend_selected")
            }

            if (message.length > 0) {
                this.loading = { show: false, message: null }
                this.set_alert_simple({
                    show: true,
                    title: "new_invoice.alert.errors.title",
                    message: message,
                })
                return
            }

            if (this.select_resend == this.add_resend) {
                this.set_alert_simple({
                    show: true,
                    title: "api.commons.alert.success.title",
                    message: ["new_invoice.alert.success"],
                })
                this.$forceUpdate()
                this.searchData()
            }
        },
        async resendInvoice(code, brand_id, uuid, email, invoice_id) {
            this.message = []
            await this.resend({
                code,
                brand_id,
                uuid,
                email,
                invoice_id 
            }).then(({ success, data, error }) => {
                if (!success && error === undefined) {
                    this.loading = { show: false, message: null }
                    this.set_alert_simple({
                        show: true,
                        title: "api.title_error_invoice",
                        message: ["api.commons.alert.error.default_error_information"],
                    })
                    return
                }
                if (!success && error.length >= 0) {
                    error.forEach((key, index) => {
                        if (key.detail != undefined && key.detail != null && key.detail != "") {
                            this.message.push(`new_invoice.alert.errors.${key.code}`, key.detail.detail)
                        } else if (key.code != "" && key.code != "error_proccess_request") {
                            this.message.push(`new_invoice.alert.errors.${key.code}`)
                        } else {
                            this.message.push(`api.commons.alert.error.error_proccess_request`)
                        }
                    })
                    this.loading = { show: false, message: null }

                    this.set_alert_simple({
                        show: true,
                        title: "api.title_error_invoice",
                        message: this.message,
                    })
                    return
                }
                if (success && data) {
                    this.add_resend += 1
                }
            })
        },

        signTraveller() {
            let message = []

            this.loading = {
                show: true,
                message: `
                    <mu-container>
                        <h5>${this.$i18n.t('loading.get_info')}</h5>
                    </mu-container>`
            }

            if (this.traveller_auth.user === null || this.traveller_auth.user === '') {
                message.push('traveller.error.auth.username')
            }
            if (message.length === 0 && this.traveller_auth.password === null || this.traveller_auth.password === '') {
                message.push('traveller.error.auth.password_empty')
            }

            if (message.length > 0) {

                this.setAlertSimple({
                    show: true,
                    title: this.$i18n.t('api.commons.alert.error.default_error'),
                    message: message
                })

                this.loading = { show: false, message: null }
                return
            }

            this.singIn({
                identify_card: this.traveller_auth.user,
                password: this.traveller_auth.password
            }).then(({ success, data, error }) => {
                if (!success && error === undefined) {
                    this.loading = { show: false, message: null }
                    this.setAlertSimple({
                        show: true,
                        title: 'api.title_error',
                        message: this.message,
                    })
                    return
                }
                if (!success && error.length >= 0) {

                    if (message.length === 0) {
                        message.push('traveller.error.auth.frequent_card_not_found')
                    }

                    this.loading = { show: false, message: null }

                    this.setAlertSimple({
                        show: true,
                        title: 'api.title_error',
                        message: message,
                    })
                    return
                }
                if (success) {
                    Object.assign(this.$data.traveller_auth, this.$options.data.call(this).traveller_auth)
                    this.getProfileSession(data)
                }
            })

        },

        getProfileSession(session) {
            let message = []

            this.profile().then(({ success, data, error }) => {

                if (!success && error === undefined) {
                    this.loading = { show: false, message: null }
                    this.setAlertSimple({
                        show: true,
                        title: 'api.title_error',
                        message: this.message,
                    })
                    return
                }
                if (!success && error.length >= 0) {

                    if (message.length === 0) {
                        message.push('traveller.error.auth.frequent_card_not_found')
                    }

                    this.loading = { show: false, message: null }

                    this.setAlertSimple({
                        show: true,
                        title: 'api.title_error',
                        message: message,
                    })
                    return
                }
                if (success) {
                    const { data: response } = data

                    this.billings = response.billing

                    this.setProfile(response)

                    this.email_invoicing = (this.getProfile.email != null) ? this.getProfile.email : null
                    this.loading = { show: false, message: null }
                    return
                }
            })
        },

        CompleteInvoicing(id) {
            let item = null

            for (let i_billing in this.billings) {
                let billing = this.billings[i_billing]
                if (billing.id == id) {
                    item = billing
                }
            }

            if (item != null) {
                this.rfc_invoicing = item.tax_id
                this.cp_invoicing = item.cp
                this.regimen_invoicing = item.regimen
                this.name_invoicing = item.name
                this.use_invoicing = item.cfdi
            }
        },

        SwitchInvoicing() {
            if (this.complete_rfc) {
                this.CompleteInvoicing(this.id_invoicing)
            }
        }
    },
    async created() {
        let itinerary = JSON.parse(localStorage.itinerary)
        this.code = itinerary.reservation.code
        this.last_name = itinerary.holder.last_name
        await this.searchData()
    },
    mounted() {
        if (this.getProfile != null) {
            this.billings = this.getProfile.billing
            this.email_invoicing = (this.getProfile.email != null) ? this.getProfile.email : null
        }
    },
}
</script>
<style lang="scss">
.mu-select-input,
.mu-select-icon {
    color: black !important
}

@media only screen and (max-width: 1170px) {
    .select-regimen {
        color: black !important
    }
}

.bx {
    color: #ffffff;
}
.statusConcept {
    width: 50px;
    background: #909497;
}

.statusConcept :hover {
    background: #797D7F;
}

.select-regimen {
    color: black !important
}

@media only screen and (max-width: 1170px) {
    .select-regimen {
        color: black !important
    }
}
</style>
